export default function isFunction(input) {
    return (
        (typeof Function !== 'undefined' && input instanceof Function) ||
        Object.prototype.toString.call(input) === '[object Function]'
    );
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-function.js
// module id = 165
// module chunks = 3